import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { alert } from './../services/alert.service';
import { authService } from '../services/auth.service';



@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(
        private alert: alert,
        private injector: Injector,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                //retry(1),
                catchError((error: HttpErrorResponse) => {
                    if (error.status === 401) {
                        this.injector.get(authService).handleUnauthorized();
                    }

                    let errorMessage = 'An unexpected error occurred.';
                    if (error.status === 0) {
                        errorMessage = 'We could not reach Coin Curiosity. Please check your connection and try again.';
                    } else if (error.error instanceof ErrorEvent) {
                        errorMessage = error.error.message || errorMessage;
                    } else {
                        errorMessage = error.error?.message || error.message || errorMessage;
                    }

                    // Billing confirmation is a bounded background poll. Its
                    // component owns retry/timeout copy, so transient responses
                    // must not create a toast on every attempt.
                    const isBillingStatusPoll = /\/billing\/status(?:\?|$)/.test(request.urlWithParams);
                    if (!isBillingStatusPoll) {
                        this.alert.responseAlert(errorMessage, 'error');
                    }
                    return throwError(() => error);
                })
            )
    }
}
